import { LayoutDashboard } from 'lucide-react';

import { DashboardErrorPage } from './DashboardErrorPage';

export function DashboardNotFound() {
    return (
        <DashboardErrorPage
            icon={LayoutDashboard}
            code="Error 404"
            title="Dashboard not found"
            message="It may have been deleted, or it belongs to another organization. Check the link, or ask the person who shared it with you."
        />
    );
}
